(function () {
  var NB = " ";
  var D = { regles: [], packs: {}, familles: {}, produits: [] };
  var R = window.MDS || {};
  var racine = (R.racine || "/").replace(/\/$/, "");
  var cache = {};
  var jeton = 0;
  var dejaVus = {};
  var courant = [];

  function produit(h) {
    if (!cache[h])
      cache[h] = fetch(racine + "/products/" + h + ".js", { headers: { Accept: "application/json" } })
        .then(function (r) {
          if (!r.ok) throw new Error("absent");
          return r.json();
        })
        .catch(function () {
          delete cache[h];
          return null;
        });
    return cache[h];
  }
  function groupe(h) {
    if (h === "chevet-colombe") return "chevets";
    if (h === "voilage-zeff") return "voilages";
    var c = D.produits.find(function (x) {
      return x.id === h;
    });
    return (c && c.fam) || h;
  }
  function euros(cts) {
    var n = cts / 100,
      c = Math.round(n * 100) % 100;
    var e = Math.floor(n + 1e-9)
      .toString()
      .replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    return e + (c ? "," + (c < 10 ? "0" : "") + c : "") + NB + "€";
  }
  function attr(t) {
    return String(t == null ? "" : t)
      .replace(/&/g, "&amp;")
      .replace(/"/g, "&quot;")
      .replace(/</g, "&lt;");
  }
  function insecable(t) {
    return attr(t)
      .replace(/(\d) x (\d)/g, "$1" + NB + "x" + NB + "$2")
      .replace(/(\d) (cm|%|€)/g, "$1" + NB + "$2")
      .replace(/ :/g, NB + ":");
  }
  function image(src, w) {
    if (!src) return "";
    src = typeof src === "string" ? src : src.src || src.url || "";
    if (src.indexOf("//") === 0) src = "https:" + src;
    return src + (src.indexOf("?") < 0 ? "?" : "&") + "width=" + (w || 200);
  }
  function option(ligne, nom) {
    var o = (ligne.options_with_values || []).find(function (x) {
      return x.name === nom;
    });
    return o ? o.value : "";
  }
  function quantite(regle, ligne) {
    var q = regle[3];
    if (!q) return 1;
    if (/^\d+$/.test(q)) return +q;
    var t = ligne.variant_title || "",
      n = 1;
    q.split(",").forEach(function (paire) {
      var p = paire.split("=");
      if (p[0] === t) n = +p[1] || 1;
    });
    return n;
  }
  function signal(action, source, nom, valeur) {
    var e = { action: action, source: source, produit: nom, valeur: valeur };
    (window.MDS_COMPLEMENTS_FILE = window.MDS_COMPLEMENTS_FILE || []).push(e);
    try {
      document.dispatchEvent(new CustomEvent("mds:complement", { detail: e }));
    } catch (x) {}
  }

  function inventaire(items) {
    var poss = {},
      grp = {};
    function ajoute(h) {
      poss[h] = 1;
      grp[groupe(h)] = 1;
    }
    items.forEach(function (it) {
      ajoute(it.handle);
      (D.packs[it.handle] || []).forEach(function (c) {
        ajoute(c[0]);
        if (c[4])
          Object.keys(c[4]).forEach(function (k) {
            ajoute(c[4][k]);
          });
      });
    });
    return { poss: poss, grp: grp };
  }

  function candidats(items) {
    var lignes = items.slice().sort(function (a, b) {
      return b.final_line_price - a.final_line_price;
    });
    var listes = lignes.map(function (it) {
      return D.regles
        .filter(function (r) {
          return r[0] === it.handle;
        })
        .map(function (r) {
          return { ligne: it, r: r };
        });
    });
    var ordre = [];
    for (var k = 0; k < 8; k++)
      listes.forEach(function (l) {
        if (l[k]) ordre.push(l[k]);
      });
    return ordre;
  }

  function construire(c, items, inv, pris) {
    var r = c.r,
      ligne = c.ligne,
      cible = r[1],
      mode = r[2],
      raison = r[4];
    if (mode === "meme") {
      if (ligne.quantity % 2 === 0) return Promise.resolve(null);
      return produit(ligne.handle).then(function (p) {
        if (!p) return null;
        var v = p.variants.find(function (x) {
          return x.id === ligne.variant_id;
        });
        if (!v || !v.available) return null;
        return {
          cle: "meme-" + ligne.key,
          nom: p.title + (ligne.variant_title ? ", " + ligne.variant_title : ""),
          url: ligne.url,
          raison: raison,
          groupe: "meme-" + ligne.handle,
          variantes: [{ id: v.id, prix: v.price, img: ligne.image, label: "" }],
          qte: 1,
          action: "meme",
          ligne: ligne,
        };
      });
    }
    if (mode === "pack") return construirePack(c, items, inv, pris);
    if (inv.poss[cible] || inv.grp[groupe(cible)] || pris[groupe(cible)]) return Promise.resolve(null);
    var famille = (D.familles || {})[cible];
    if (famille && mode !== "coloris") return construireFamille(c, famille);
    return produit(cible).then(function (p) {
      if (!p || !p.available) return null;
      var vs = p.variants.filter(function (v) {
        return v.available;
      });
      var m = /^taille=(.+)$/.exec(mode);
      if (m)
        vs = vs.filter(function (v) {
          return (v.options || []).indexOf(m[1]) >= 0;
        });
      if (mode === "coloris") {
        var col = option(ligne, "Coloris");
        vs = vs.filter(function (v) {
          return v.title === col;
        });
      }
      if (!vs.length) return null;
      var simple = p.variants.length === 1 || mode === "coloris";
      return {
        cle: cible,
        nom: p.title + (m ? " " + m[1] : ""),
        url: p.url,
        raison: raison,
        groupe: groupe(cible),
        variantes: vs.map(function (v) {
          var lab = simple
            ? ""
            : m
              ? (v.options || [])
                  .filter(function (o) {
                    return o !== m[1];
                  })
                  .join(", ")
              : v.title;
          return {
            id: v.id,
            prix: v.price,
            img: (v.featured_image && v.featured_image.src) || p.featured_image,
            label: lab,
          };
        }),
        qte: quantite(r, ligne),
        action: "ajout",
        unite: groupe(cible),
      };
    });
  }

  function construireFamille(c, famille) {
    var r = c.r,
      cible = r[1],
      m = /^taille=(.+)$/.exec(r[2]);
    return Promise.all(famille.h.map(produit)).then(function (ps) {
      var tete =
        ps.find(function (p) {
          return p && p.handle === cible;
        }) || ps.find(Boolean);
      var out = [];
      ps.forEach(function (p) {
        if (!p || !p.available) return;
        p.variants.forEach(function (v) {
          if (!v.available || (m && (v.options || []).indexOf(m[1]) < 0)) return;
          out.push({
            id: v.id,
            prix: v.price,
            img: (v.featured_image && v.featured_image.src) || p.featured_image,
            label: (v.options || [])
              .filter(function (o) {
                return !m || o !== m[1];
              })
              .join(", "),
          });
        });
      });
      if (!out.length || !tete) return null;
      return {
        cle: cible,
        nom: (famille.n || tete.title) + (m ? " " + m[1] : ""),
        url: tete.url,
        raison: r[4],
        groupe: groupe(cible),
        variantes: out,
        qte: quantite(r, c.ligne),
        action: "ajout",
        unite: groupe(cible),
      };
    });
  }

  function construirePack(c, items, inv, pris) {
    var pack = c.r[1],
      compo = D.packs[pack];
    if (!compo || inv.poss[pack]) return Promise.resolve(null);
    var presents = [],
      manquants = [];
    compo.forEach(function (it) {
      var l = items.find(function (x) {
        var memeProduit =
          x.handle === it[0] ||
          (it[4] &&
            Object.keys(it[4]).some(function (k) {
              return it[4][k] === x.handle;
            }));
        return (
          memeProduit &&
          x.quantity >= it[2] &&
          (!it[1] ||
            (x.options_with_values || []).some(function (o) {
              return o.value === it[1];
            }))
        );
      });
      if (l) presents.push({ it: it, ligne: l });
      else manquants.push(it);
    });
    if (manquants.length !== 1 || !presents.length) return Promise.resolve(null);
    var manque = manquants[0];
    if (inv.grp[groupe(manque[0])] || pris[groupe(manque[0])]) return Promise.resolve(null);
    var parColoris = manque[4] || null;
    var autres = parColoris
      ? Object.keys(parColoris).map(function (k) {
          return parColoris[k];
        })
      : [];
    return Promise.all([produit(pack), produit(manque[0])].concat(autres.map(produit))).then(function (res) {
      var pp = res[0],
        pm = res[1];
      if (!pp || !pm || !pp.available) return null;
      var fiches = {};
      res.slice(1).forEach(function (x) {
        if (x) fiches[x.handle] = x;
      });
      var vs = pp.variants.filter(function (v) {
        return v.available;
      });
      var suivi = presents.find(function (x) {
        return x.it[3];
      });
      if (suivi) {
        var vals = (suivi.ligne.options_with_values || []).map(function (o) {
          return o.value;
        });
        vs = vs.filter(function (v) {
          return vals.indexOf(v.title) >= 0;
        });
      }
      var base = presents.reduce(function (s, x) {
        return s + x.ligne.price * x.it[2];
      }, 0);
      var out = [];
      vs.forEach(function (v) {
        var pv = (parColoris && fiches[parColoris[v.title]]) || pm;
        var vm =
          pv.variants.find(function (x) {
            var o = x.options || [x.title];
            return (!manque[1] || o.indexOf(manque[1]) >= 0) && (manque[3] !== "Coloris" || o.indexOf(v.title) >= 0);
          }) || pv.variants[0];
        if (!vm.available && parColoris) return;
        var delta = v.price - base,
          seul = vm.price * manque[2];
        if (delta <= 0 || seul - delta <= 0) return;
        out.push({
          id: v.id,
          prix: delta,
          seul: seul,
          img: (vm.featured_image && vm.featured_image.src) || pv.featured_image,
          label: suivi ? "" : v.title,
        });
      });
      if (!out.length) return null;
      return {
        cle: pack,
        nom:
          (manque[2] > 1 ? manque[2] + NB + "x " : "") +
          (((D.familles || {})[manque[0]] || {}).n || pm.title) +
          (manque[1] ? " " + manque[1] : ""),
        url: pp.url,
        raison: c.r[4],
        groupe: groupe(manque[0]),
        variantes: out,
        qte: 1,
        action: "pack",
        retirer: presents.map(function (x) {
          return { cle: x.ligne.key, q: x.ligne.quantity - x.it[2] };
        }),
      };
    });
  }

  function prixTexte(x, v) {
    if (x.action === "pack")
      return "<b>" + euros(v.prix) + "</b> avec l'ensemble, soit " + euros(v.seul - v.prix) + " de moins";
    if (x.qte > 1)
      return (
        "<b>" +
        euros(v.prix * x.qte) +
        "</b> les " +
        x.qte +
        (x.unite === "chaises" ? " paires" : x.unite === "rideaux" ? " rideaux" : "")
      );
    return "<b>" + euros(v.prix) + "</b>";
  }
  function carte(x, i) {
    var v = x.variantes[0];
    var choix =
      x.variantes.length > 1
        ? '<select class="upsell-item__select" data-complement-choix="' +
          i +
          '" aria-label="Choisir">' +
          x.variantes
            .map(function (y, k) {
              return '<option value="' + k + '">' + attr(y.label) + "</option>";
            })
            .join("") +
          "</select>"
        : "";
    return (
      '<div class="upsell-item upsell-item--complement" data-complement="' +
      i +
      '">' +
      '<a class="upsell-item__media" href="' +
      attr(x.url) +
      '"><img class="upsell-item__image" data-complement-img src="' +
      attr(image(v.img, 200)) +
      '" alt="" loading="lazy" width="72" height="72"></a>' +
      '<div class="upsell-item__body"><a class="upsell-item__name" href="' +
      attr(x.url) +
      '">' +
      insecable(x.nom) +
      "</a>" +
      '<p class="upsell-item__why">' +
      insecable(x.raison) +
      "</p>" +
      choix +
      '<div class="upsell-item__row"><span class="upsell-item__price" data-complement-prix>' +
      prixTexte(x, v) +
      "</span>" +
      '<button type="button" class="upsell-item__button" data-complement-ajout="' +
      i +
      '">Ajouter</button></div></div></div>'
    );
  }

  function sourceDe(bloc) {
    return bloc.getAttribute("data-source") || (bloc.closest("#panier") ? "tiroir" : "page panier");
  }
  function visible(bloc) {
    if (bloc.hidden) return false;
    var t = bloc.closest("#panier");
    if (t) return t.classList.contains("is-open");
    var b = bloc.getBoundingClientRect();
    return b.top < innerHeight && b.bottom > 0;
  }
  function signalerVus(bloc) {
    if (!visible(bloc)) return;
    var s = sourceDe(bloc);
    courant.forEach(function (x) {
      var k = s + "|" + x.cle;
      if (!dejaVus[k]) {
        dejaVus[k] = 1;
        signal("vu", s, x.nom);
      }
    });
  }

  function rendre(panier, catalogue) {
    var blocs = document.querySelectorAll("[data-associer]");
    if (!blocs.length) return;
    var items = (panier && panier.items) || [];
    var j = ++jeton;
    if (!items.length) {
      blocs.forEach(function (b) {
        b.hidden = true;
      });
      courant = [];
      return;
    }
    (catalogue ? catalogue() : Promise.resolve(D)).then(function (donnees) {
      if (j !== jeton) return;
      D = donnees;
      proposer(items, j, blocs);
    });
  }

  function proposer(items, j, blocs) {
    var inv = inventaire(items),
      pris = {},
      choisis = [],
      liste = candidats(items);
    (function suite(k) {
      if (j !== jeton) return;
      if (choisis.length >= 2 || k >= liste.length) return afficher();
      construire(liste[k], items, inv, pris).then(
        function (x) {
          if (
            x &&
            !choisis.some(function (y) {
              return y.cle === x.cle;
            })
          ) {
            choisis.push(x);
            pris[x.groupe] = 1;
          }
          suite(k + 1);
        },
        function () {
          suite(k + 1);
        },
      );
    })(0);
    function afficher() {
      if (j !== jeton) return;
      courant = choisis;
      blocs.forEach(function (b) {
        var l = b.querySelector("[data-associer-liste]");
        b.hidden = !choisis.length;
        if (l) l.innerHTML = choisis.map(carte).join("");
        signalerVus(b);
      });
    }
  }

  function ajouter(bouton) {
    var i = +bouton.getAttribute("data-complement-ajout"),
      x = courant[i];
    if (!x) return;
    var item = bouton.closest("[data-complement]"),
      sel = item && item.querySelector("select");
    var v = x.variantes[sel ? +sel.value : 0];
    var bloc = bouton.closest("[data-associer]"),
      source = bloc ? sourceDe(bloc) : "tiroir";
    var json = { "Content-Type": "application/json", Accept: "application/json" };
    bouton.disabled = true;
    bouton.textContent = "Ajout…";
    var p;
    if (x.action === "meme") {
      p = fetch(racine + "/cart/change.js", {
        method: "POST",
        headers: json,
        body: JSON.stringify({ id: x.ligne.key, quantity: x.ligne.quantity + 1 }),
      });
    } else {
      p = fetch(racine + "/cart/add.js", {
        method: "POST",
        headers: json,
        body: JSON.stringify({ items: [{ id: v.id, quantity: x.qte }] }),
      });
      if (x.action === "pack")
        p = p.then(function (r) {
          if (!r.ok) return r;
          return x.retirer
            .reduce(function (acc, z) {
              return acc.then(function () {
                return fetch(racine + "/cart/change.js", {
                  method: "POST",
                  headers: json,
                  body: JSON.stringify({ id: z.cle, quantity: z.q }),
                });
              });
            }, Promise.resolve())
            .then(function () {
              return r;
            });
        });
    }
    p.then(function (r) {
      if (!r.ok) throw new Error("refus");
      signal("ajouté", source, x.nom, Math.round(v.prix * (x.action === "pack" ? 1 : x.qte)) / 100);
      if (/\/cart\/?$/.test(location.pathname)) {
        location.reload();
        return;
      }
      bouton.textContent = "Ajouté";
      if (window.MdsPanier) window.MdsPanier.charger();
    }).catch(function () {
      bouton.disabled = false;
      bouton.textContent = "Ajouter";
      if (window.MdsPanier) window.MdsPanier.charger();
    });
  }

  document.addEventListener("click", function (e) {
    var b = e.target.closest && e.target.closest("[data-complement-ajout]");
    if (b) {
      e.preventDefault();
      ajouter(b);
    }
  });
  document.addEventListener("change", function (e) {
    var s = e.target.closest && e.target.closest("[data-complement-choix]");
    if (!s) return;
    var x = courant[+s.getAttribute("data-complement-choix")],
      v = x && x.variantes[+s.value];
    if (!v) return;
    var item = s.closest("[data-complement]");
    var img = item.querySelector("[data-complement-img]");
    if (img && v.img) img.src = image(v.img, 200);
    var px = item.querySelector("[data-complement-prix]");
    if (px) px.innerHTML = prixTexte(x, v);
  });
  var tiroir = document.getElementById("panier");
  if (tiroir && window.MutationObserver)
    new MutationObserver(function () {
      var b = tiroir.querySelector("[data-associer]");
      if (b) signalerVus(b);
    }).observe(tiroir, { attributes: true, attributeFilter: ["class"] });
  addEventListener(
    "scroll",
    function () {
      document.querySelectorAll("[data-associer]").forEach(function (b) {
        if (!b.closest("#panier")) signalerVus(b);
      });
    },
    { passive: true },
  );

  window.MdsComplements = { rendre: rendre };
})();
